import { Link } from 'react-router-dom'

export default function SupportPage() {
  return (
    <div style={s.page}>
      <div style={s.content}>
        <p style={s.eyebrow}>Help</p>
        <h1 style={s.title}>Support</h1>
        <p style={s.sub}>Something not working? Question about your account? We're here.</p>

        <div style={s.cards}>
          <Card title="General questions" email="hello@themarginsjournal.com"
            desc="Platform questions, feedback, partnership enquiries." />
          <Card title="Account & technical issues" email="support@themarginsjournal.com"
            desc="Sign-in problems, lost content, bugs, feature requests." />
          <Card title="Privacy & data" email="privacy@themarginsjournal.com"
            desc="Data requests, GDPR enquiries, account deletion." />
          <Card title="Content & moderation" email="editorial@themarginsjournal.com"
            desc="Report a post, appeal a moderation decision, editorial questions." />
        </div>

        <div style={s.faq}>
          <h2 style={s.faqTitle}>Common questions</h2>

          <Q q="How do I delete my account?">
            Email support@themarginsjournal.com with the subject "Account deletion" from your registered email address. We'll delete your account and all associated data within 7 days.
          </Q>
          <Q q="How do I export my writing?">
            Dashboard → Export tab → Download as Plain Text or Markdown. All your published pieces are included.
          </Q>
          <Q q="What is Column Inches (CI)?">
            CI is the rank currency on The Margins. You earn it by publishing, receiving reactions, and getting comments. Reactions on older posts earn more CI — timeless writing is worth more.
          </Q>
          <Q q="Can I publish anonymously?">
            Yes. The Cold Open toggle in the write sidebar lets you publish without your name. You can claim the piece later from the post page.
          </Q>
          <Q q="Why was my post removed?">
            Posts are removed if they violate our one rule (mean it) or our Terms of Service. Email editorial@themarginsjournal.com to appeal.
          </Q>
          <Q q="How do I reset my password?">
            On the sign-in page, click "Forgot password?" and enter your email. You'll receive a reset link within a few minutes.
          </Q>
        </div>

        <p style={{ fontFamily: "'DM Mono', monospace", fontSize: '0.62rem', color: 'var(--muted)', marginTop: '3rem' }}>
          <Link to="/privacy" style={s.link}>Privacy Policy</Link>
          {' · '}
          <Link to="/terms" style={s.link}>Terms of Service</Link>
        </p>
      </div>
    </div>
  )
}

function Card({ title, email, desc }) {
  return (
    <a href={`mailto:${email}`} style={s.card}>
      <div style={s.cardTitle}>{title}</div>
      <div style={s.cardEmail}>{email}</div>
      <div style={s.cardDesc}>{desc}</div>
    </a>
  )
}

function Q({ q, children }) {
  return (
    <div style={s.qItem}>
      <p style={s.qQ}>{q}</p>
      <p style={s.qA}>{children}</p>
    </div>
  )
}

const s = {
  page: { paddingTop: '4.5rem', minHeight: '100vh' },
  content: { maxWidth: 720, margin: '0 auto', padding: '4rem 2rem 6rem' },
  eyebrow: { fontFamily: "'DM Mono', monospace", fontSize: '0.62rem', letterSpacing: '0.16em', textTransform: 'uppercase', color: 'var(--accent)', marginBottom: '0.75rem' },
  title: { fontFamily: "'Space Grotesk', sans-serif", fontSize: 'clamp(2rem, 5vw, 2.8rem)', fontWeight: 700, letterSpacing: '-0.02em', marginBottom: '0.75rem' },
  sub: { fontFamily: "'Space Grotesk', sans-serif", fontSize: '1rem', color: 'var(--muted)', lineHeight: 1.7, marginBottom: '3rem' },
  cards: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '1rem', marginBottom: '3rem' },
  card: { display: 'block', padding: '1.25rem 1.5rem', background: 'var(--cream)', border: '1px solid var(--rule)', borderRadius: 10, textDecoration: 'none', transition: 'border-color 0.15s' },
  cardTitle: { fontFamily: "'Space Grotesk', sans-serif", fontSize: '0.95rem', fontWeight: 700, marginBottom: '0.25rem', color: 'var(--ink)' },
  cardEmail: { fontFamily: "'DM Mono', monospace", fontSize: '0.65rem', color: 'var(--accent)', marginBottom: '0.5rem', letterSpacing: '0.04em' },
  cardDesc: { fontFamily: "'Space Grotesk', sans-serif", fontSize: '0.82rem', color: 'var(--muted)', lineHeight: 1.6 },
  faq: { borderTop: '1px solid var(--rule)', paddingTop: '2.5rem' },
  faqTitle: { fontFamily: "'Space Grotesk', sans-serif", fontSize: '1.2rem', fontWeight: 700, marginBottom: '1.5rem' },
  qItem: { marginBottom: '1.75rem', paddingBottom: '1.75rem', borderBottom: '1px solid var(--rule)' },
  qQ: { fontFamily: "'Space Grotesk', sans-serif", fontSize: '0.95rem', fontWeight: 700, marginBottom: '0.5rem', color: 'var(--ink)' },
  qA: { fontFamily: "'Space Grotesk', sans-serif", fontSize: '0.9rem', color: 'var(--muted)', lineHeight: 1.7 },
  link: { color: 'var(--accent)', textDecoration: 'underline' },
}
